import Amplitude from 'amplitude-js';
import {isProduction} from "../agent";

const STAGING_KEY = '024fa27a6ebfd996c5b01a0ab664b7ff';
const PRODUCTION_KEY = '7e341b78ca127f41503e5771516e66ba';

export function init() {
    Amplitude && Amplitude.getInstance().init(isProduction ? PRODUCTION_KEY : STAGING_KEY, undefined, {
        apiEndpoint: 'api2.amplitude.com'
    });
}

export function setUserId(userId: string) {
    Amplitude && Amplitude.getInstance().setUserId(userId);
}

export function logEvent(name: string, properties: any = {}) {
    Amplitude && Amplitude.getInstance().logEvent(name, properties);
}

export const events = {
    land_on_welcome_page: 'land_on_welcome_page',
    land_on_login_page: 'land_on_login_page',
    land_on_verify_phone_number_page: 'land_on_verify_phone_number_page',
    land_on_get_started_page: 'land_on_get_started_page',
    land_on_select_group_page: 'land_on_select_group_page',
    land_on_create_group_page: 'land_on_create_group_page',
    land_on_edit_deeplink_group_page: 'land_on_edit_deeplink_group_page',
    land_on_choose_group_type_page: 'land_on_choose_group_type_page',
    land_on_add_welcome_post_page: 'land_on_add_welcome_post_page',
    land_on_group_settings_page: 'land_on_group_settings_page',
    land_on_input_email_page: 'land_on_input_email_page',
    land_on_intro_screen_page: 'land_on_intro_screen_page',
    land_on_landing_screen_page: 'land_on_landing_screen_page',
    land_on_link_settings_page: 'land_on_link_settings_page',
    land_on_link_generate_link_page: 'land_on_link_generate_link_page',
    open_final_preview_page: 'open_final_preview_page',
}
